import { TimelineZoomLimits } from "../../constants/zoomRange";

export default t => {
  switch (t) {
    case "billion":
      return TimelineZoomLimits.Billion;
    case "million":
      return TimelineZoomLimits.Million;
    case "thousand":
      return TimelineZoomLimits.Thousand;
    case "century":
      return TimelineZoomLimits.Century;
    case "decade":
      return TimelineZoomLimits.Decade;
    case "year":
      return TimelineZoomLimits.Year;
    case "month":
      return TimelineZoomLimits.Month;
    case "week":
      return TimelineZoomLimits.Week;
    case "day":
      return TimelineZoomLimits.Day;
    case "hour":
      return TimelineZoomLimits.Hour;
    case "minute":
      return TimelineZoomLimits.Minute;
    case "second":
      return TimelineZoomLimits.Second;
    default:
      return TimelineZoomLimits.Month;
  }
};
